<template>
  <div class="container"  @mouseleave="handleDown">
    <div class="context">
      <div class="left" id="myDiv">
        <div class="more_box">
            全部商品分类
          </div>
        <div class="item" @click="TitleCommodityId1(item)" v-for="item,index in enableMenuList" :key="item.cate_id" :class="activeClass == index?'activeClass': ''"
          @mouseenter="handleEnter(item,index)"
        > 
         
          <el-skeleton style="width: 280px;padding-top:5px;" :loading="loading" animated :rows="9">
            <p style="font-size:14px;"> 
              <!-- <i class="el-icon-truck"></i> -->
              {{ item.cate_name }}</p>
            <div class="itemP">
              <span>{{ item.remark }}</span>
            </div>
          </el-skeleton>
        </div>
        <!-- <div class="item" @click="TitleCommodityId1(item)" v-for="item,index in enableMenuList" :key="item.cate_id" :class="activeClass == index?'activeClass': ''"
          @mouseenter="handleEnter(item,index)"
        > 
         
          <el-skeleton style="width: 280px" :loading="loading" animated :rows="9">
            <p> 
              {{ item.cate_name }}</p>
            <div class="itemP">
              <span>{{ item.remark }}</span>
            </div>
          </el-skeleton>
        </div> -->
        
          <div class="positionIs" >
            <div class="IsItem" style="padding-top:20px;">
                <div class="itemContext" v-for="sub in posItem.children" :key="sub.cate_id">
                  <div class="posTitle" @click="TitleCommodityId2(posItem,sub,sub.children)"> {{ sub.cate_name }}<i class="el-icon-arrow-right"></i></div>
                  <div class="posUl">
                    <ul>
                      <li v-for="s_sub in sub.children" :key="s_sub.cate_id" @click="TitleCommodityId3(posItem,sub,s_sub)">
                        {{ s_sub.cate_name }}
                      </li>
                      
                    </ul>
                  </div>
                </div>
            </div>
          </div>
      </div>
      <div class="center">
         <div class="carousel">
          <!-- <el-carousel height="465px" :interval="4000" autoplay> -->
          <el-carousel :height="carouselHeight" :interval="4000" autoplay>
              <el-carousel-item v-for="item in carouselList" :key="item.id" class="carouselImage" >
                  <div>
                    <img :src="item.firstFile.FileUrl" style="width: 100%;object-fit: cover;" alt="">
                  </div>
              </el-carousel-item>
          </el-carousel>  
        </div>
      </div>
    </div>
   
    
  </div>
</template>

<script>
export default{
    data(){
        return {
            parentCateValue: 'product',
            enableMenuList: [],
            posItem: '',
            loading: true,
            carouselList:[],
            activeClass: -1,
            carouselHeight: '450px',
            showPosi: false,
            timerId: null
        }
    },
    methods: {
      handleEnter(item,index){
        this.showPosi = true
        this.posItem = item
        this.activeClass = index
      },
      handleDown(){
        this.activeClass = -1
        this.showPosi = false
      },
      HandleImage(){
         let data = {
            cate_value: "homebanner"
          }
          this.$store.dispatch('login/listads',data)
            .then(res => {
                this.carouselList = res.data.items
            })
      },
      TitleCommodityId1(item){
          console.log(item);
         
          sessionStorage.setItem('enableItem',JSON.stringify(item))
          sessionStorage.setItem('enableSub','')
          sessionStorage.setItem('s_subs','')
          this.$router.push({
              path: '/enable'
          })
          
      },
      TitleCommodityId2(item,subItem){
          console.log(item);
          console.log(subItem);
          sessionStorage.setItem('enableItem',JSON.stringify(item))
          sessionStorage.setItem('enableSub',JSON.stringify(subItem))
          sessionStorage.setItem('s_subs','')
          this.$router.push({
              path: '/enable'
          })
          
      },
      TitleCommodityId3(item,subItem,s_sub){
          console.log(item);
          console.log(subItem);
          console.log(s_sub);
          sessionStorage.setItem('enableItem',JSON.stringify(item))
          sessionStorage.setItem('enableSub',JSON.stringify(subItem))
          sessionStorage.setItem('s_subs',JSON.stringify(s_sub))
          this.$router.push({
              path: '/enable'
          })
          
      },

      MenuList(){
        let data = {
          parent_cate_value: this.parentCateValue
        }
        this.$store.dispatch('enable/listCateNew',data)
            .then(res => {
              console.log(res.data)
                if(res.ok){
                    this.loading = false
                    console.log("loading----"+this.loading);
                    const DataList = res.data
                    this.enableMenuList = DataList
                    this.posItem = this.enableMenuList[0]
                    
                    this.$emit('enableMenuList', this.enableMenuList);
                    this.timerId = setTimeout(this.getHeight, 1500);
                }
            }).catch(err => {
                console.log(err);
            })
      },
      getHeight(){
          // 使用 clientHeight 属性获取 div 的高度
          var myDiv = document.getElementById("myDiv");
          var height = myDiv.clientHeight;
          console.log(height);

          this.$nextTick(() =>{
            this.carouselHeight = height + 'px'
            clearTimeout(this.timerId)
          })
      }
       
    },
    mounted(){
      this.loading = true
      this.MenuList()
      this.HandleImage()
        
    },
  
}
</script>

<style lang='scss' scoped>
.container {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 10px;
  
  .context{
    width: 1200px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    position: relative;
    .left{
      width: 240px;
      // height: 460px;
      padding-bottom: 5px;
      // overflow-y: scroll;
      background: #fff;
      
      .more_box{
          line-height: 40px;
          margin-bottom: 5px;
          background-color: #10aeff;
          font-size: 16px;
          color: #fff;
          padding-left: 10px;
        }
      .item{
        margin: 0px 10px 3px 10px;
        padding: 1px 0 0 0px;
        font-size: 16px;
       
        // padding-bottom: 5px;
        p{
          font-size: 16px;
          // font-weight: 700;
          cursor: pointer;
          // padding-left: 5px;
          // margin-bottom: 5px;
          i{
            width: 10px 10px;
            margin-right: 6px;
            // color: #333333;
          }
        }
        .itemP{
          height: 100%;
          margin-top: 0px;
          padding: 0 0;
          span{
            padding: 3px 0px 0 0px;
            overflow: hidden;
            font-size: 12px;
            color: #999999;
            margin: 5px 0px;
            cursor: pointer;
          }
          
        }
      }
      .activeClass{
        background: #f8f5f5;
      }
      .activeClass .itemP span{
        color: #10aeff;
      }
      .activeClass i{
        color: #10aeff;
      }
      
      .positionIs{
        position: absolute;
        width: 960px;height: 100%;
        // height: 465px;
        // min-height: 465px;
        top: 0;
        left: 240px;
        right: 10px;
        overflow-y: scroll !important;
        font-size: 14px;
        // display: none;
        .IsItem{
          margin-left: 10px;
          background: #fff;
          min-height: 100%;
          .itemContext{
            display: flex;
            justify-content: flex-start;
            padding: 5px 0;
            margin-bottom: -10px;
            .posTitle{
              text-align: right;
              padding: 0 5px;
              font-size: 14px;
              font-weight: 700;
              min-width: 170px;
              cursor: pointer;
            }
            .posTitle:hover{
              color: #10aeff;
            
            }
            .posUl{
              margin-left: 8px;
              ul{
                padding: 0 5px 3px 0;
                li{
                  margin: 0px 15px 10px 0;
                  padding-bottom: 2px;
                  font-size:14px;
                }
              }
            }
          }
        }
      }
      .positionIs:hover{
        display: block;
      }
      .item:hover+.positionIs{
        display: block;
      }
      /* 修改滚动条的样式 */
      .positionIs::-webkit-scrollbar {
        width: 8px; /* 设置滚动条宽度 */
      }

      .positionIs::-webkit-scrollbar-track {
        background-color: #ffffff; /* 设置滚动条轨道背景色 */
      }

      .positionIs::-webkit-scrollbar-thumb {
        background-color: #888; /* 设置滚动条滑块颜色 */
      }

      .positionIs::-webkit-scrollbar-thumb:hover {
        background-color: #555; /* 设置滚动条滑块在鼠标悬停时的颜色 */
      }
     
    }
    
    .left:hover .positionIs{
      display: block;
    }
    .left:hover+ .center{
      display: none;
    }
    .center{
      width: 950px;
      // height: 464px;
      background: #fff;
      .carousel{
        width: 100%;height: 100%;
      }
    }
    .right{
      width: 205px;height: 700px;
      border: 1px solid;
      background: #fff;
    }
  }
  
}
ul{
  margin: 0 0;
  font-size: 16px;
  color: #333333;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: row wrap;
  li{
    margin: 3px 5px;
    cursor: pointer;
  }
  li:hover{
    color: #10aeff;
  }
}
::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    ::-webkit-scrollbar-track {
        background-color:transparent;
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius:2em;
    }
    ::-webkit-scrollbar-thumb {
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius:2em;
    }

</style>